import { createSlice } from '@reduxjs/toolkit'
import { IModalReducers, IModalState } from './modal.slice.types'

const initialState: IModalState = {
  modalConfig: {
    variant: 'closed',
  },
}

export const modalSlice = createSlice<IModalState, IModalReducers, string>({
  name: 'modal',
  initialState,
  reducers: {
    closeModal: (state) => {
      state.modalConfig.variant = 'closed'
    },
    openModal: (state, action) => {
      state.modalConfig = action.payload
    },
  },
})

export const ModalActions = modalSlice.actions
export const modalReducer = modalSlice.reducer
